module.exports = __webpack_public_path__ + "static/media/future-tense-table-4.1203be39.PNG";